import "./index.css";
import V4MonographStars from "./concepts/v4-monograph-stars";

export default function App() {
  return <V4MonographStars />;
}
